import {
  displayOrDash,
  getDrugTestTypeLabel,
  getGlanceResolutionLabel,
  getGlanceSourceParts,
  getRecheckLabel,
  getShortReportId,
} from '../utils';
import {
  Mono,
  RecheckBadge,
  ResolutionValue,
  SectionLabel,
  SummaryGrid,
  SummaryItem,
  SummaryLabel,
  SummaryValue,
} from './styled';
import type { ReportAtAGlanceProps } from './types';

const ReportAtAGlance = ({ report }: ReportAtAGlanceProps) => {
  if (!report) return null;

  const hasCaseNumber = Boolean(report.case_number?.trim());
  const recheckLabel = getRecheckLabel(report.recheck);
  const isRecheck = report.recheck?.id != null;
  const sourceParts = getGlanceSourceParts(report.source);
  const resolutionLabel = getGlanceResolutionLabel(report.resolution);

  return (
    <section>
      <SectionLabel>Report at a glance</SectionLabel>
      <SummaryGrid>
        <SummaryItem>
          <SummaryLabel>Case number</SummaryLabel>
          <SummaryValue>{hasCaseNumber ? <Mono>{report.case_number}</Mono> : displayOrDash(null)}</SummaryValue>
        </SummaryItem>

        {!hasCaseNumber ? (
          <SummaryItem>
            <SummaryLabel>Report ID</SummaryLabel>
            <SummaryValue>
              <Mono>{getShortReportId(report.id)}</Mono>
            </SummaryValue>
          </SummaryItem>
        ) : null}

        <SummaryItem>
          <SummaryLabel>Type</SummaryLabel>
          <SummaryValue>{getDrugTestTypeLabel(report)}</SummaryValue>
        </SummaryItem>

        <SummaryItem>
          <SummaryLabel>Source</SummaryLabel>
          <SummaryValue>
            {sourceParts ? (
              <>
                {sourceParts.label} · <Mono>{sourceParts.enumValue}</Mono>
              </>
            ) : (
              displayOrDash(null)
            )}
          </SummaryValue>
        </SummaryItem>

        <SummaryItem>
          <SummaryLabel>Recheck</SummaryLabel>
          <SummaryValue>{isRecheck ? <RecheckBadge>{recheckLabel}</RecheckBadge> : recheckLabel}</SummaryValue>
        </SummaryItem>

        <SummaryItem>
          <SummaryLabel>Status</SummaryLabel>
          <SummaryValue>{displayOrDash(report.status)}</SummaryValue>
        </SummaryItem>

        <SummaryItem>
          <SummaryLabel>Resolution</SummaryLabel>
          {report.resolution && resolutionLabel ? (
            <ResolutionValue tone={report.resolution}>{resolutionLabel}</ResolutionValue>
          ) : (
            <SummaryValue>{displayOrDash(null)}</SummaryValue>
          )}
        </SummaryItem>

        <SummaryItem>
          <SummaryLabel>Order reason</SummaryLabel>
          <SummaryValue>{displayOrDash(report.type?.order_reason)}</SummaryValue>
        </SummaryItem>

        <SummaryItem>
          <SummaryLabel>Override reason</SummaryLabel>
          <SummaryValue>{displayOrDash(report.override_reason)}</SummaryValue>
        </SummaryItem>
      </SummaryGrid>
    </section>
  );
};

export default ReportAtAGlance;
